import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { GlobalNavigationLineOfBusiness } from '__generated__/api/types';

import { Header as HeaderBernie } from '@gc/global-components';
import { MyList } from './my-list';
import { Qualtrics } from './qualtrics';

export interface HeaderProps {
  className?: string;
  searchCriteria?: SearchCriteriaModel;
}

export const Header: React.FunctionComponent<HeaderProps> = ({ className, searchCriteria }) => (
  <HeaderBernie
    className={className}
    lineOfBusiness={GlobalNavigationLineOfBusiness.HOTEL}
    customJourneyCriterias={customJourneyCriterias(searchCriteria)}
  >
    <MyList />
    {/* the Qualtrics experiments below are for different POSes and will not have more than one bucketed in */}
    <Experiment name="PWA_Qualtrics_Intercept">
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <Qualtrics />
      </ExperimentVariant>
    </Experiment>
    <Experiment name="PWA_Qualtrics_Intercept_for_BEX_Rest_of_World">
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <Qualtrics />
      </ExperimentVariant>
    </Experiment>
    <Experiment name="PWA_Qualtrics_Intercept_for_Comet">
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <Qualtrics />
      </ExperimentVariant>
    </Experiment>
  </HeaderBernie>
);
Header.displayName = 'Header';

const customJourneyCriterias = searchCriteria => {
  let customJourneyCriteria = null;
  const { regionId, startDate, endDate } = searchCriteria || {};
  if (Number(regionId)) {
    customJourneyCriteria = [
      {
        destination: {
          regionId: regionId,
        },
        dateRange: {
          startDate: startDate,
          endDate: endDate,
        },
      },
    ];
  }

  return customJourneyCriteria;
};
